import React from 'react';
import { get } from 'lodash';
import FormFields from '../form-fields/FormFields';
import FieldGroup from '../form-fields/FieldGroup';

interface FieldProp {
	type: string;
	path: string;
	[key: string]: any; // Allows additional props to be passed
}

interface FieldGroupProp {
	userProps?: string;
	fields?: FieldProp[];
}

interface CreateFormProps {
	formStruc: any[];
	formValues: Record<string, any> | {};
	updateFormValuesFunc: (fieldName: string, value: any) => void;
	formErrors?: Record<string, any>;
	readOnly?: boolean;
	[key: string]: any; // Allows additional props to be passed
}

const CreateForm: React.FC<CreateFormProps> = (props) => {
	const { formStruc, formValues, formErrors, updateFormValuesFunc, readOnly } = props;
	const formComponents = (
		<>
			{(formStruc || []).map((eachFieldRow: FieldGroupProp, i: number) => (
				<FieldGroup key={i} userProps={get(eachFieldRow, 'userProps', '')} eachFieldProps={eachFieldRow}>
					{get(eachFieldRow, 'fields', []).map((fieldProp: FieldProp, index: number) => (
						<FormFields
							key={index}
							formValues={formValues}
							formErrors={formErrors}
							onChange={updateFormValuesFunc}
							readOnly={readOnly ? readOnly : false}
							{...fieldProp}
						/>
					))}
				</FieldGroup>
			))}
		</>
	);
	return formComponents;
};

export default CreateForm;
